import { Hero } from "@/components/Hero";
import cn from "classnames";

import classes from "./styles.module.scss";

export default function ({
  className,
  title,
  image,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <Hero
      className={cn(className, classes.JobsHero)}
      title={title}
      image={image}
      EditableText={EditableText}
      EditableHtml={EditableHtml}
      EditableImage={EditableImage}
      theme={theme}
    />
  );
}
